import React from 'react';

import { ArrowIcon } from '../../../../assets/svg/ArrowIcon';
import { ICarouselArrowBtn } from '../CarouselTypes';
import styles from './CarouselArrowButtons.module.scss';

export const CarouselArrowNext: React.FC<ICarouselArrowBtn> = ({
  onClick,
  isInfinite = false,
  isHidden,
}) => {
  const isDisabled = !isInfinite && isHidden;

  if (isDisabled) return null;

  return (
    <button
      className={styles.carouselArrowRightBtn}
      onClick={onClick}
      aria-label="show the next slide"
    >
      <ArrowIcon className={styles.carouselArrowRightIcon} />
    </button>
  );
};
